import React from 'react';
import './Features.css';

function Features() {
  return (
    <section className="features">
      <div className="features-container">
        <h2>Our Services</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>iOS Development</h3>
            <p>Native iOS applications</p>
          </div>
          <div className="feature-card">
            <h3>Android Development</h3>
            <p>Native Android applications</p>
          </div>
          <div className="feature-card">
            <h3>Cross-Platform</h3>
            <p>Multi-platform with React Native</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;